// Auto-generated from errors.algo.ts - do not edit manually
/**
 * Map of error codes to human-readable error messages
 */
export const ErrorMessages = {
    "ERR:CODE": "Human readable description`",
    "ERR:AUTH": "Unauthorized - caller must be admin",
    "ERR:SA_ID": "setAdmin2 must be immediately preceded by a call to this app",
    "ERR:SA_SIG": "setAdmin2 must be immediately preceded by a setAdmin1 call",
    "ERR:SA_OC": "Preceding setAdmin1 call must be a NoOp",
    "ERR:SA_CLR": "setAdmin2 must be sent by the new admin nominated in setAdmin1",
    "ERR:ZADDR": "Zero address is not allowed",
    "ERR:ZASA": "Asset ID must not be zero",
    "ERR:W_EMP": "At least one account must be provided",
    "ERR:A_EMP": "At least one asset must be provided",
    "ERR:AC_EX": "Asset config already exists for this asset",
    "ERR:AC_NX": "Asset config does not exist",
    "ERR:AC_MAX": "Asset config limit reached (255)",
    "ERR:AC_PRE": "Claim token prefix must not be empty",
    "ERR:W_EX": "Account is already whitelisted for this asset",
    "ERR:W_NX": "Account is not whitelisted for this asset or has no claims remaining",
    "ERR:NO_BOX": "Account has no whitelist or token-claim box to delete",
    "ERR:A_OPT": "Claimer is not opted in to the claim asset",
    "ERR:A_BAL": "Contract does not hold enough of the claim asset to fulfill the claim",
    "ERR:A_STA": "Claim period for this asset has not started yet - redemptions are not open",
    "ERR:A_END": "Claim period for this asset has ended - no more redemptions are possible",
    "ERR:TS_NS": "Token claims are disabled - midnight token signer has not been configured",
    "ERR:TS_LEN": "Token signer must be a 32 byte ed25519 public key",
    "ERR:T_SIG": "Token signature is invalid for this claimer. Make sure to claim with the account you had connected at midnight UTC.",
    "ERR:T_CLM": "Account has already claimed with a token",
    "ERR:B_QTY": "Burn quantity must be greater than zero",
    "ERR:B_APP": "ARC-54 burn app id must not be zero"
};
